import { ITheme } from "../../Theme/Theme.types.js";
import { ButtonProps } from "../Button.types.js";

export const getVerticalPadding = ({ size, theme }: { size: NonNullable<ButtonProps["size"]>; theme: ITheme }) => {
    if (size === "small") return theme.spacing[8];
    if (size === "medium") return theme.spacing[12];
    return theme.spacing[16];
};

export const getHorizontalPadding = ({ variant, theme }: { variant: NonNullable<ButtonProps["variant"]>; theme: ITheme }) => {
    if (variant === "ghost") return "0";
    return theme.spacing[24];
};

export const getPadding = ({
    size,
    variant,
    theme,
}: {
    size: NonNullable<ButtonProps["size"]>;
    variant: NonNullable<ButtonProps["variant"]>;
    theme: ITheme;
}): string => {
    return `${getVerticalPadding({ size, theme })} ${getHorizontalPadding({ variant, theme })}`;
};
